import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons';

import { DaysPanelComponent } from './days-panel.component';

@NgModule({
  declarations: [DaysPanelComponent],
  exports: [DaysPanelComponent],
  imports: [CommonModule, FontAwesomeModule],
})
export class DaysPanelModule {
  constructor(library: FaIconLibrary) {
    // Font Awesome Icons to consume
    library.addIcons(faCheck, faTimes);
  }
}
